import type { App as Application } from 'vue'
import { useUser } from 'src/store/modules/App/user'
export default {
  install: function (app: Application): void {
    app.config.globalProperties.$isSameUser = function (id: number): boolean {
      const userStore = useUser()
      if (!userStore.user?.id) {
        return false
      }

      return userStore.user.id === id
    }
  },
}
